/**
 * Gets the value of a cookie by name.
 * @param {string} name - The name of the cookie.
 * @returns {string|null} - The value of the cookie, or null if not found.
 */
function getCookie(name) {
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [cookieName, cookieValue] = cookie.split("=");
		if (cookieName === name) {
			return decodeURIComponent(cookieValue);
		}
	}
	return null;
}

document.addEventListener("DOMContentLoaded", () => {
	// get a cookie
	const userSignedUp = getCookie("user-signed-up");
	// exit if use already signed up
	if (userSignedUp == "true") return;

	// get panel
	const panel = document.getElementById("newsletter-overlay");
	// exit if no panel available
	if (!panel) return;

	// show panel
	panel.setAttribute("aria-hidden", "false");
});
